module.exports = __webpack_public_path__ + "static/media/paw.937ccda7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/paw.svg
// module id = 217
// module chunks = 0